export const LANGUAGES = {
  ENGLISH: 'en',
  SPANISH: 'es',
} as const
